module.exports = __webpack_public_path__ + "static/media/chat.8fd9c863.svg";